<template>
  <div class="PageIndicator">
    <button
      v-for="page of count"
      :key="page"
      type="button"
      class="PageIndicator-dot"
      :class="{ 'is-active': page - 1 === activePage }"
      :aria-current="page - 1 === activePage ? 'page' : undefined"
      :aria-label="dotLabel?.(page)"
      @click="activePage = page - 1"
    />
  </div>
</template>

<script setup lang="ts">
import type { PageIndicatorProps } from './PageIndicator.model';

defineProps<PageIndicatorProps>();

const activePage = defineModel<number>({ default: 0 });
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;

@layer cvo-ui {
  .PageIndicator {
    display: flex;
    gap: vars.$dimensions-d-1;
    align-items: center;
    justify-content: center;

    &-dot {
      position: relative;
      width: vars.$dimensions-d-2;
      height: vars.$dimensions-d-2;
      padding: 0;
      background-color: vars.$atoms-page-indicator-dot-color-inactive;
      border: none;
      border-radius: vars.$border-radius-full;
      cursor: pointer;
      transition: width vars.$transition-fast, background-color vars.$transition-fast;

      // Invisible overlay growing the 8px dot to a comfortable hit target, up to the midpoint of the gap.
      &::after {
        content: '';
        position: absolute;
        inset-block: calc(-1 * vars.$dimensions-d-2);
        inset-inline: calc(-1 * vars.$dimensions-d-0-5);
      }

      // The active page reads as a pill.
      &.is-active {
        width: vars.$dimensions-d-5;
        background-color: vars.$atoms-page-indicator-dot-color-active;
      }
    }
  }
}
</style>
